import axiosInstance from "../lib/axiosInstance";

class cartModel {

    constructor() {
        this.base_url = "/carts"
    }
    async list(query = []) {
       
        return (await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)).data;
    }
    async create(data=[]) {
        return await axiosInstance.post(this.base_url, data);
    }
    async update(id, data = []) {
        return await axiosInstance.post(`${this.base_url}/${id}?_method=PUT`, data);
    }
    async destroy(id,data=[]) {
        return await axiosInstance.delete(`${this.base_url}/${id}`, data);
    }
    async show(id) {
        return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
    }
       

}

export default new cartModel();